module.exports = __webpack_public_path__ + "img/3-7848.7dec8f16.png";